import { useField } from 'react-final-form';
import { useFieldArray } from 'react-final-form-arrays';

import { TBlock } from '@wp-block-builder/blocks/types';

export function useEditableBlock(name: string) {
  return useEditableBlockInput(name).value;
}

export function useEditableBlockInput(name: string) {
  return useField<TBlock>(name).input;
}

export function useEditableBlocks(name: string) {
  return useField<TBlock[]>(name).input.value;
}

export function useEditableBlocksArrayField(name: string) {
  return useFieldArray<TBlock>(name).fields;
}
